<template>
  <div>
    <div class="page case-detail__content">
        <div class="bg-content padding15">
          <el-form size="small" ref="searchRef" label-width="100px">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="公司">
                  <el-select v-model="searchReq.companyId" style="width: 100%;" placeholder="请选择" filterable @change="companyChange">
                    <template v-for="item in companyNameList">
                      <el-option
                        :key="item.id"
                        :value="item.id"
                        :label="item.companyName"
                        :title="item.companyName">
                        <template>
                          <span v-if="item.companyName.length > 15">{{item.companyName.substring(0,15) + '...'}}</span>
                          <span v-else>{{item.companyName}}</span>
                        </template>
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="贷款机构">
                  <el-select v-model="searchReq.loanInstitutions" style="width: 100%;" placeholder="请选择" multiple collapse-tags filterable>
                    <template v-for="item in LoanInstitutionsList">
                      <el-option
                        :key="item"
                        :value="item"
                        :label="item"
                        :title="item">
                      </el-option>
                    </template>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="作业时间">
                  <el-date-picker v-model="searchReq.createTime" style="width: 100%;" type="date" placeholder="选择日期时间"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="至">
                  <el-date-picker v-model="searchReq.endTime" style="width: 100%;" type="date" placeholder="选择日期时间"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="text right">
              <el-button type="primary" size="small" plain @click="getList();">搜索</el-button>
              <el-button size="small" @click="searchReq.companyId = null; searchReq.createTime = null; searchReq.endTime = null">重置</el-button>
            </div>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-table
            size="small"
            v-loading="loading"
            :data="accountRes.list">
            <el-table-column
              property="workTime"
              label="作业日"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.workTime">{{scope.row.workTime}}</span>
                <span v-else style="font-weight: bold;">统计</span>
              </template>
            </el-table-column>
            <el-table-column
              property="workCaseCount"
              label="作业案件量"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.workTime">{{scope.row.workCaseCount}}</span>
                <span v-else style="font-weight: bold;">{{scope.row.workCaseCount}}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="msgCount"
              label="短信计费量"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.workTime">{{scope.row.msgCount}}</span>
                <span v-else style="font-weight: bold;">{{scope.row.msgCount}}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="ivrCount"
              label="语音计费量"
              align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.workTime">{{scope.row.ivrCount}}</span>
                <span v-else style="font-weight: bold;">{{scope.row.ivrCount}}</span>
              </template>
            </el-table-column>
            <el-table-column
              property="msgCost"
              label="短信计费"
              align="center"
              v-if="this.$hasPerm('Z021&1')">
              <template slot-scope="scope">
                <span v-if="scope.row.msgCost && scope.row.workTime">{{scope.row.msgCost | formatRate}}</span>
                <span v-else-if="scope.row.msgCost && !scope.row.workTime" style="font-weight: bold;">{{scope.row.msgCost | formatRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              property="ivrCost"
              label="语音计费"
              align="center"
              v-if="this.$hasPerm('Z021&1')">
              <template slot-scope="scope">
                <span v-if="scope.row.ivrCost && scope.row.workTime">{{scope.row.ivrCost | formatRate}}</span>
                 <span v-else-if="scope.row.ivrCost && !scope.row.workTime" style="font-weight: bold;">{{scope.row.ivrCost | formatRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              property="totalCost"
              label="计费总量"
              align="center"
              v-if="this.$hasPerm('Z021&1')">
              <template slot-scope="scope">
                <span v-if="scope.row.totalCost && scope.row.workTime">{{scope.row.totalCost | formatRate}}</span>
                <span v-else-if="scope.row.totalCost && !scope.row.workTime" style="font-weight: bold;">{{scope.row.totalCost | formatRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column
              property="followUnitCost"
              label="跟进单价"
              align="center"
              v-if="this.$hasPerm('Z021&1')">
              <template slot-scope="scope">
                <span v-if="scope.row.followUnitCost && scope.row.workTime">{{scope.row.followUnitCost | formatRate}}</span>
                <span v-else-if="scope.row.followUnitCost && !scope.row.workTime" style="font-weight: bold;">{{scope.row.followUnitCost | formatRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      searchReq: {
        companyId: null,
        loanInstitutions: [],
        createTime: '2021-03-02',
        endTime: ''
      },
      accountRes: { 'totalRecords': 0, list: [] },
      roleRes: [],
      companyNameList: [],
      LoanInstitutionsList: []
    };
  },
  mounted() {
    this.companyList();
    // const date = new Date();
    // eslint-disable-next-line no-mixed-operators
    // date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
    // this.searchReq.createTime = date;
  },
  methods: {
    getList() {
      if (!this.searchReq.companyId) {
        this.$message({
          type: 'error',
          message: '请选择公司！'
        });
        return;
      }
      // if (!this.searchReq.loanInstitutions) {
      //   this.$message({
      //     type: 'error',
      //     message: '请选择贷款机构！'
      //   });
      //   return;
      // }
      if (!this.searchReq.createTime) {
        this.$message({
          type: 'error',
          message: '请选择作业开始时间！'
        });
        return;
      }
      this.loading = true;
      this.$ajax({
        method: 'POST',
        url: '/companyCost/getCostCalculationList',
        data: this.searchReq
      }).then((res) => {
        this.accountRes.list = res.data;
        this.loading = false;
      });
    },
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyRes = res.data;
        this.companyNameList = res.data;
        this.getLoanInstitutionsList(res.data[0].id);
        if (this.companyNameList.length > 0) {
          this.searchReq.companyId = res.data[0].id;
          this.getList();
        }
      });
    },
    companyChange() {
      this.searchReq.loanInstitutions = [];
      this.getLoanInstitutionsList(this.searchReq.companyId);
    },
    getLoanInstitutionsList(companyId) {
      this.$ajax({
        url: '/company/getLoanInstitutionsList',
        params: { companyId }
      }).then((res) => {
        this.LoanInstitutionsList = res.data;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/costCalculation/index.vue